import React, { useEffect, useState, useRef } from "react";
import { Translator } from './translator';

const NFT = () => {
  const { translateText, lang } = Translator();

  const baseText = {
    text1: "NFTteche Marketplace",
    text2: "Colleziona l'anima dei nostri tour: arte, cultura e territorio in formato digitale.",
    text3: "Passione d’Argilla",
    text4: 'NFT “Passione d’Argilla”',
    text5: "Il “mummolo” cilentano",
    text6: `Questo NFT narra una storia di energia e creatività del suo creatore Pompeo Cammarano, intento alla lavorazione dell’argilla cilentana: il “Mummolo” di argilla.
            È un NFT che celebra la tradizione millenaria della pratica dell’argilla in Costiera Amalfitana.
            Qui sfumature tra il rosso e gli “scuri” intensi evocano atmosfera di immaginazione e di un “fare” passionale.
            Questo NFT è il numero 1 del gruppo “rosso” in edizione limitata di 1550 NFT supply totale, in cui sono inseriti 4 NFT ultra rari, 6 NFT super rari, 3 alieni e 1 speciale autografato dall’autore.
            La società garantisce che di questi non ne saranno coniati altri.`,
    text7: "Vivi l’arte digitale “NFTteche”: prenota il tuo NFT in prereveal a un prezzo piccolissimo scontato dell’80% sul floor price e fai un grande investimento per il futuro.",
    text8: "Prossimamente",
  };


  const [translatedText, setTranslatedText] = useState(baseText);
  const nftImages = ["NFT1.jpg" ];
  const [selectedImg, setSelectedImg] = useState(null);
  const [isClosing, setIsClosing] = useState(false);
  const modalRef = useRef(null);

  React.useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setSelectedImg(null);
    }
  };

  if (selectedImg) {
    window.addEventListener("keydown", handleKeyDown);
  }

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [selectedImg]);



useEffect(() => {
  const translateAll = async () => {
    const entries = Object.entries(baseText);
    const translatedEntries = await Promise.all(
      entries.map(async ([key, value]) => [key, await translateText(value)])
    );
    setTranslatedText(Object.fromEntries(translatedEntries));
  };

  translateAll();
}, [lang]);



useEffect(() => {
  const handleClickOutside = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setSelectedImg(null); // ✅ this closes the modal
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [selectedImg]);


  // Smooth closing
  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setSelectedImg(null);
      setIsClosing(false);
    }, 500); // match animation duration
  };


  return (
    <div className="min-h-screen bg-[#f2f2f2] text-black px-6 py-10 font-sans">

      <img
        src="https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/NFT/COPERTINA-NFT.jpg"
        alt="Copertina NFT"
        className="w-full aspect-[4/2] object-contain rounded-xl bg-[#f2f2f2]"
      />

      {/* ─────────────── Title + subtitle ────────────── */}
      <h2 className="text-4xl font-bold text-black text-center mt-10">
        {translatedText.text1}
      </h2>


      <p className="text-center mt-4 text-lg">
        {translatedText.text2}
      </p>


      {/* ───────────────  Image gallery  ─────────────── */}
      <section
        className={`mt-10 px-4 ${
          nftImages.length %3 <= 1
            ? "flex justify-center items-center min-h-[60vh] gap-6 flex-wrap"
            : "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 justify-center"
        }`}
      >
        {nftImages.map((img, index) => (
          <div
            key={index}
            className="relative bg-white rounded-xl shadow-md overflow-hidden w-72 opacity-70 cursor-not-allowed"
          >
            {/* NFT Image */}
            <img
              src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/NFT/${img}`}
              alt={`NFT ${index + 1}`}
              className="w-full aspect-[3/4] object-cover"
              draggable={false}
            />

            {/* Card content */}
            <div className="p-2 text-center font-medium text-sm">
              {translatedText.text3}
              <div className="text-[#000000] mt-1">19.5 MATIC</div>
            </div>

            {/* Coming Soon overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <span className="bg-white text-black px-4 py-1 rounded-full text-xs font-semibold shadow">
                🚀 {translatedText.text8}
              </span>
            </div>
          </div>
        ))}
      </section>


      
      {/* Modal */}
      {selectedImg && (
        <div
          className={`fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4 ${
            isClosing ? "animate-fadeOut" : "animate-fadeIn"
          }`}
        >

          <div
            ref={modalRef}
                className="bg-white p-6 rounded-lg shadow-lg w-[90vw] max-w-[800px] relative max-h-[90vh] overflow-y-auto animate-slideUp"

          >
            <button
              className="absolute top-3 right-3 text-gray-700 hover:text-black text-xl leading-none w-8 h-8 flex items-center justify-center rounded-full bg-white shadow-md"
              onClick={closeModal}
              aria-label="Close modal"
            >
              ×
            </button>

            <img
              src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Teche/NFT/${selectedImg}`}
              alt="NFT Enlarged"
              className="w-full max-h-[300px] object-contain rounded mb-4"
            />

            <div className="text-left text-sm sm:text-base leading-relaxed text-gray-800">
              <p><strong>{translatedText.text4}</strong> </p>
              <p><strong>{translatedText.text5}</strong></p>
              <p className="mt-2">
                {translatedText.text6}
              </p>
              <p className="mt-4 font-semibold text-red-600">
                {translatedText.text7}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NFT;